import InfiniteScroll from "infinite-scroll";

const $blogWrapper = $(".blog__inner");
if ($blogWrapper.length && $blogWrapper.find(".load-more").length) {
  const infinite = new InfiniteScroll(".blog__inner", {
    path: ".load-more",
    append: ".blog__item,.blog__paginate",
    history: false
  });

  infinite
    .on("request", function() {
      $blogWrapper.find(".blog__paginate").addClass("loading");
    })
    .on("load", function() {
      $blogWrapper.find(".blog__paginate").remove();
    });
}



// WEBPACK FOOTER //
// ../assets/js/infinite-scroll.js